import { api, appCommons } from '@/app/shared/services';

import { apiConstants } from '../../config';

const fetchGuide = (payload) => {
  const url = apiConstants.fetchGuide;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchTags = (payload) => {
  const url = apiConstants.fetchTags;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchArtefacts = (payload) => {
  const url = apiConstants.fetchArtefacts;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchArtefact = (payload) => {

  let reqTypes = {
    sdt: 'store',
    sst: 'store',
    sdf: 'store',
    spo: 'store',
    scdf: 'product_category',
    cdf: 'product_category',
    pot: 'store'
  };
  let scopeList = [];
  let tagList = [];
  let refList = [];
  let unitList = [];
  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
      if(tag.type === 'U') {
        unitList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "req_type": reqTypes[payload.type.toLowerCase()],
    "product_category_list": refList,
    "brand_list": tagList,
    "store_code_list": scopeList,
    "sku_id_list": unitList
  }

//  return api.get(endpoint);
  return api.post(endpoint, params);
};

const fetchArtefactUnit = (payload) => {

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let endpoint = apiConstants['spo'];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "req_type": payload.type.indexOf('B') !== -1 ? "brand" : "product_category",
    "product_category_list": refList,
    "brand_list": tagList,
    "store_code_list": scopeList
  }

//  return api.get(endpoint);
  return api.post(endpoint, params);
};

const fetchDummy = (payload) => {

  let reqTypes = {
    sst: 'store',
    sdf: 'store',
    spo: 'store',
    scdf: 'product_category',
    cdf: 'product_category',
    pot: 'store'
  };
  let scopeList = [];
  let tagList = [];
  let refList = [];
  let unitList = [];
  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
      if(tag.type === 'U') {
        unitList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {
    "client": "gex",
    "from_date": payload.dateRange ? payload.dateRange.startDate : new Date(),
    "to_date": payload.dateRange ? payload.dateRange.endDate : new Date(),
    "metric" : payload.mode ? payload.mode : "revenue",
    "req_type": reqTypes[payload.type.toLowerCase()],
    "product_category_list": refList,
    "brand_list": tagList,
    "store_code_list": scopeList,
    "sku_id_list": unitList
  }

 return api.get(endpoint);
  // return api.post(endpoint, params);
};

const fetchMock = (payload) => {

  let endpoint = apiConstants[payload.type.toLowerCase()+'_mock'];
  
  if(!endpoint) {
    endpoint = 'mock-data/mock.json'
  }
  return api.get(endpoint);
};

export { fetchGuide, fetchTags, fetchArtefacts, fetchArtefact, fetchArtefactUnit, fetchDummy, fetchMock };
